import './HooPowAppMenuV2.scss'

import React, { useEffect, useState } from 'react';

import HooPowDS from './HooPowDS';

export const routeToPlatformHomePage = () => {
  if(process.env.REACT_APP_DOMAIN_NAME === "awlad-school.com") return "https://www.hoo-pow.com"
  const protocol = process.env.REACT_APP_DOMAIN_NAME !== 'localhost' ? 'https' : 'http';
  const port = process.env.REACT_APP_DOMAIN_NAME !== 'localhost' ? '' : ':3001';
  return protocol + '://' + (process.env.REACT_APP_DOMAIN_NAME === "hoo-pow.com" ? "www.hoo-pow.com" : process.env.REACT_APP_DOMAIN_NAME) + port
}

function HooPowAppMenuV2(props: { isAwladOnlyUser: boolean }) {
  const [applications, setApplications] = useState<any[]>();

  useEffect(() => {
    if (process.env.REACT_APP_HOOPOW_API_ENPOINT_BASE_URL) {
      HooPowDS.getPlatformDef().then((platformDef: any) => {
        setApplications(platformDef.application);
      });
    }
  }, []);

  return (
    <div className="hp-menu-icon">
      {document.domain !== "awlad-school.com" && applications && (<>
        <a href={routeToPlatformHomePage()} className="hp-menu-icon--link" >
          <span>
            <object type='image/svg+xml' data={routeToPlatformHomePage() + '/icon.svg'} aria-label='HooPow' />
          </span>
        </a>
        {applications.filter((appDef: any) => appDef.publicationDate < new Date().toISOString()).map((appDef: any, index) => {
          return (
            <React.Fragment key={index}>
              <a href={appDef.url} className="hp-menu-icon--link" key={index}>
                <span>
                  <object type='image/svg+xml' data={appDef.url + '/icon.svg'} aria-label={appDef.name} />
                </span>
              </a>
            </React.Fragment>
          );
        })}
      </>)}
    </div>
  );
}

export default HooPowAppMenuV2;
